module.exports = __webpack_public_path__ + "static/media/dedicated-wellness.32d2683e.jpg";